var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFocusFilled = function SvgFocusFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.565 3.685a.5.5 0 0 0 0 1 3.314 3.314 0 0 1 3.31 3.31v5.253a4.303 4.303 0 0 0-3.31-1.554 4.315 4.315 0 0 0-4.28 3.81h-2.57a4.315 4.315 0 0 0-4.28-3.81c-1.329 0-2.519.606-3.31 1.554V7.996a3.314 3.314 0 0 1 3.31-3.31.5.5 0 0 0 0-1 4.315 4.315 0 0 0-4.31 4.31v8.009a4.315 4.315 0 0 0 4.31 4.31 4.315 4.315 0 0 0 4.28-3.81h2.57a4.315 4.315 0 0 0 4.28 3.81 4.315 4.315 0 0 0 4.31-4.31v-8.01a4.315 4.315 0 0 0-4.31-4.31Z",
    fill: "#000"
  })));
};
export default SvgFocusFilled;